import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid, Modal, Button } from 'framework-ui-components';
import { erratiCodiciFiscaliDichiarazione } from 'apis/setteTrentaApi';
import { EsitoControlloSiatel } from 'enums';

const _initialData = {
    IdAnagraficaDichiarante: null,
    IdAnagraficaConiuge: null,
    CodiceFiscaleDichiarante: null,
    CognomeDichiarante: null,
    NomeDichiarante: null,
    CodiceFiscaleConiuge: null,
    DenominazioneConiuge: null,
    dichiaranteErrato: false,
    coniugeErrato: false,
    altriErrati: false,
    codiciFiscaliDichiarazione: [],
    loading: false
};

class ModaleInfoCodiceFiscale extends Component {
    state = {
        ..._initialData
    }

    componentWillReceiveProps({ show, data, idDichiarazione, idDichiarazioneConiuge }) {
        if (show != this.props.show && show) {
            this.setState(data);
            this.caricaCodiciFiscali(idDichiarazione, idDichiarazioneConiuge);
        }
    }

    caricaCodiciFiscali = (idDichiarazione, idDichiarazioneConiuge) => {
        this.setState({ loading: true }, () => {
            erratiCodiciFiscaliDichiarazione(idDichiarazione, idDichiarazioneConiuge,this.props.annoSelezionato)
                .then(res => {
                    let dichiaranteErrato = res.find(x => x.CodiceFiscale == this.state.CodiceFiscaleDichiarante &&
                        (x.Stato != EsitoControlloSiatel.DaControllare && x.Stato != EsitoControlloSiatel.ControlloInCorso && x.Stato != EsitoControlloSiatel.Corretto));
                    let coniugeErrato = res.find(x => x.CodiceFiscale == this.state.CodiceFiscaleConiuge &&
                        (x.Stato != EsitoControlloSiatel.DaControllare && x.Stato != EsitoControlloSiatel.ControlloInCorso && x.Stato != EsitoControlloSiatel.Corretto));
                    let altriErrati = res.filter(x => x.CodiceFiscale != this.state.CodiceFiscaleDichiarante && x.CodiceFiscale != this.state.CodiceFiscaleConiuge &&
                        (x.Stato != EsitoControlloSiatel.DaControllare && x.Stato != EsitoControlloSiatel.ControlloInCorso && x.Stato != EsitoControlloSiatel.Corretto));
                    this.setState({
                        codiciFiscaliDichiarazione: res,
                        dichiaranteErrato: dichiaranteErrato,
                        coniugeErrato: coniugeErrato,
                        altriErrati: altriErrati,
                        loading: false
                    });
                });
        });
    }

    annulla = () => {
        const { onClose } = this.props;
        this.setState(_initialData, () => {
            onClose && onClose();
        });
    }

    correggi = () => {
        const { onCorreggi, onClose } = this.props;

        onCorreggi && onCorreggi();
        onClose();
    }

    riapri = () => {
        const { onRiapri, onClose } = this.props;
        onRiapri && onRiapri();
        onClose();
    }

    visualizza = () => {
        const { onVisualizza } = this.props;
        onVisualizza && onVisualizza();
    }

    render() {

        const { isLoading, show } = this.props;
        const { dichiaranteErrato, coniugeErrato, altriErrati, loading } = this.state;
        const width = "6";

        return (
            <Modal loading={isLoading || loading} onClose={this.annulla} show={show}>
                <Modal.Header>
                    Dichiarazione scartata per codici fiscali
                </Modal.Header>
                <Modal.Body>
                    <Grid fluid>
                        <Grid.Row>
                            <Grid.Col md="12">
                                Questa dichiarazione &egrave; stata scartata a causa di errori nei codici fiscali contenuti.
                            </Grid.Col>
                        </Grid.Row>
                        <Grid.Row>
                            {(dichiaranteErrato || coniugeErrato) &&
                                <Grid.Col md={width} className="centraColonna">
                                    Sono presenti errori nei codici fiscali del {dichiaranteErrato ? <span>dichiarante</span> : <span>coniuge</span>} {dichiaranteErrato && coniugeErrato && <span> e del coniuge</span>} {altriErrati && altriErrati.length > 0 && <span>, dei familiari o del sostituto d'imposta</span>}.

                                    Correggi questi errori.
                                <br /><br />
                                </Grid.Col>
                            }

                            {!dichiaranteErrato && !coniugeErrato && altriErrati && altriErrati.length > 0 &&
                                <Grid.Col md={width} className="centraColonna">
                                    Sono presenti errori nei codici fiscali dei familiari o del sostituto d'imposta <br />
                                    {altriErrati.map((x, i) =>
                                        (<Grid.Row key={i}>
                                            <Grid.Col md="12"><b>{x.CodiceFiscale}</b>: {x.DescrizioneStato} {x.NuovoCodiceFiscale && <span>({x.NuovoCodiceFiscale})</span>}</Grid.Col>
                                        </Grid.Row>)
                                    )}
                                    <br /><br />
                                </Grid.Col>
                            }

                            <Grid.Col md={width} className="centraColonna">
                                Visualizza la dichiarazione per identificare gli errori.
                                <br /><br />
                            </Grid.Col>
                        </Grid.Row>
                        <Grid.Row>
                            {(dichiaranteErrato || coniugeErrato) &&
                                <Grid.Col md={width} className="centraColonna">
                                    <Button flat primary onClick={this.correggi}>Correggi</Button>
                                </Grid.Col>
                            }

                            {!dichiaranteErrato && !coniugeErrato && altriErrati && altriErrati.length > 0 &&
                                <Grid.Col md={width} className="centraColonna">
                                    <Button flat primary onClick={this.riapri}>Riporta in lavorazione</Button>
                                </Grid.Col>
                            }

                            <Grid.Col md={width} className="centraColonna">
                                <Button flat primary onClick={this.visualizza}>Visualizza</Button>
                            </Grid.Col>
                        </Grid.Row>
                    </Grid>
                </Modal.Body>
            </Modal>
        );
    }
}

ModaleInfoCodiceFiscale.propTypes = {
    errore: PropTypes.string,
    idDichiarazione: PropTypes.string.isRequired,
    idDichiarazioneConiuge: PropTypes.string,
    isLoading: PropTypes.bool,
    onClose: PropTypes.func,
    onModifica: PropTypes.func,
    show: PropTypes.bool,
    annoSelezionato:PropTypes.number
};

export default ModaleInfoCodiceFiscale;